<template>
  <div :class="{'has-logo':showLogo}">
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        ref="menu"
        :default-active="defaultActiveMenu"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="true"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
        @select="onMenuSelect">
        <sidebar-item v-for="route in permission_routes" :key="route.path" :item="route" :base-path="route.path" />
      </el-menu>
    </el-scrollbar>
    <div v-if="isAdmin" class="export-excel">
      <!-- <div class="line"></div> -->
      <!-- <span>导出报表</span> -->
      <el-button class="export-btn" icon="Download" round @click="exportExcel">
        导出报表
      </el-button>
    </div>
    <div v-else class="contact-UPS">
      <p>如有问题，请联系我们</p>
      <el-popover
        v-model="visible"
        popper-class="info-popover"
        placement="right"
        width="360">
        <div class="info">
          <p class="info-title">
            <span>联系方式信息</span>
            <i class="el-icon-close info-title_close" @click="visible = false"></i>
          </p>
          <el-scrollbar class="info-popover-scroll">
            <div class="info-popover-container">
              <dl class="info-item">
                <dt class="info-label">出口单证</dt>
              </dl>
              <dl class="info-item">
                <dt class="info-label">上海口岸：</dt>
                <dd class="info-value">联系邮箱：Jiang Yun Tao <el-link type="primary" href="mailto:yxjiang@ups.com">yxjiang@ups.com</el-link></dd>
              </dl>
              <dl class="info-item">
                <dt class="info-label">郑州口岸：</dt>
                <dd class="info-value">联系邮箱：Li Ping <el-link type="primary" href="mailto:liperry@ups.com">liperry@ups.com</el-link></dd>
              </dl>
            </div>
          </el-scrollbar>
        </div>
        <template #reference>
          <el-button round class="btn-contact-UPS">联系UPS</el-button>
        </template>
      </el-popover>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem.vue'
import variables from '@/styles/variables.module.scss'
import request from '@/request'
import cacheInLocalStorage from '@/store/cache/cacheInLocalStorage'
export default {
  components: { SidebarItem },
  props: {
    isAdmin: {
      type: Boolean,
      default: undefined
    }
  },
  data() {
    return {
      visible: false,
      defaultActiveMenu: '',
      staffInfo: cacheInLocalStorage.get('staffInfo') ? JSON.parse(cacheInLocalStorage.get('staffInfo')) : null
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        this.$nextTick(() => {
          const { meta, path } = route
          if (meta.activeMenu) {
            this.defaultActiveMenu = meta.activeMenu
          } else {
            this.defaultActiveMenu = path
          }
        })
      }
    }
  },
  computed: {
    ...mapGetters([
      'permission_routes',
      'sidebar']
    ),
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  created() {
    this.$bus.$on('updateActiveMenu', val => {
      if (val) {
        this.$nextTick(() => {
          this.defaultActiveMenu = val
        })
      }
    })
    this.$bus.$on('need-update-admin-clearance-add-count', val => {
      // 列表审结或者退单时要刷新新增显示
      this.httpGetNewCount()
    })
    const isB = cacheInLocalStorage.get('isB')
    if (isB) {
      this.httpGetNewCount()
      setInterval(() => {
        this.httpGetNewCount()
      }, 1000 * 60 * 3)
    }
  },
  methods: {
    exportExcel() {
      this.$emit('show', true)
    },
    onMenuSelect(index, indexPath) {
      if (index === '/customers-status-query') {
        this.$refs.menu.close('/customers-center')
        this.$refs.menu.close('/customs-clearance-supply')
      }
    },
    httpGetNewCount() {
      var url = ''
      if (this.staffInfo && (this.staffInfo.roleList[0].fixedRole === '主管理员' || this.staffInfo.roleList[0].fixedRole === '异常处理管理员')) {
        url = '/api/v1/business/admin/declarations/total-count'
      } else {
        url = '/api/v1/business/declarations/total-count'
      }
      request({
        url: url,
        method: 'get',
        hiddenLoading: true
      }).then(res => {
        this.$bus.$emit('update-admin-clearance-add-count', res)
      })
    }
  }
}
</script>
<style scoped lang="scss">
  .export-excel {
    cursor: pointer;
    width: 100%;
    height: 60px;
    line-height: 60px;
    color: black;
    text-align: center;
    position: absolute;
    /* left: 0; */
    right: 0;
    bottom: 20px;
    padding: 20px 20px;
    /*margin-right: 10px;*/
    /* margin: 0px 16px 0 16px; */
    /*margin-left: 10px;*/
    .line {
      width: 100%;
      border-bottom: 1px solid #7191BE;
    }
    span {
      background: url("../../../assets/img/admin/icon-export.png") left center no-repeat;
      background-size: 20px 20px;
      font-size: 16px;
      color: #7191BE;
      padding-left: 30px;
    }
    span:hover {
      background: url("../../../assets/img/admin/icon-export-hover.png") left center no-repeat;
      background-size: 20px 20px;
      font-size: 16px;
      color: #7191BE;
      padding-left: 30px;
    }
    span:active {
      background: url("../../../assets/img/admin/icon-export-click.png") left center no-repeat;
      background-size: 20px 20px;
      font-size: 16px;
      color: #7191BE;
      padding-left: 30px;
    }
    .export-btn {
      background: #00857D;
      color: white;
      border-color: #00857D;
    }
  }
    .contact-UPS {
      position: absolute;
      z-index: 1002;
      bottom: 8px;
      left: 8px;
      width: 263px;
      height: 105px;
      background: #EDEDED;
      text-align: center;
    p {
      color: #363636;
      font: bold 14px 'Noto Sans CJK SC Medium';
      padding-top: 18px;
      }
    .btn-contact-UPS {
      background: #02857D;
      border-color: #02857D;
      color: #ffffff;
      margin-top: 15px;
      }
    }
    .info-popover {
    .info {
      font-size: 16px;
      padding: 10px;
      height: 280px;
      overflow: hidden;
      .info-title {
        padding-bottom: 10px;
        display: flex;
        justify-content: space-between;
        font-weight: bold;
        .info-title_close {
          font-weight: bold;
          cursor: pointer
        }
      }
      .info-item {
        margin-bottom:15px;
        .info-label {
          height:42px;
          line-height:42px
        }
        .info-value {
          height:25px;
          line-height:25px
        }
      }
    }
    .info-popover-scroll {
      height: 100%;
    }
  }
</style>
